import { IconOptions } from 'leaflet'
import { ReactComponent as AmicPin } from '@dataplace.ai/assets/lib/markers/brand/amicPin.svg'
import { ReactComponent as AviaPin } from '@dataplace.ai/assets/lib/markers/brand/aviaPin.svg'
import { ReactComponent as BliskaPin } from '@dataplace.ai/assets/lib/markers/brand/bliskaPin.svg'
import { ReactComponent as BPPin } from '@dataplace.ai/assets/lib/markers/brand/bpPin.svg'
import { ReactComponent as CircleKPin } from '@dataplace.ai/assets/lib/markers/brand/circleKPin.svg'
import { ReactComponent as HuzarPin } from '@dataplace.ai/assets/lib/markers/brand/huzarPin.svg'
import { ReactComponent as KFCPin } from '@dataplace.ai/assets/lib/markers/brand/kfcPin.svg'
import { ReactComponent as LotosPin } from '@dataplace.ai/assets/lib/markers/brand/lotosPin.svg'
import { ReactComponent as MCDPin } from '@dataplace.ai/assets/lib/markers/brand/mcdPin.svg'
import { ReactComponent as MolPin } from '@dataplace.ai/assets/lib/markers/brand/molPin.svg'
import { ReactComponent as OrlenPin } from '@dataplace.ai/assets/lib/markers/brand/orlenPin.svg'
import { ReactComponent as PieprzykPin } from '@dataplace.ai/assets/lib/markers/brand/pieprzykPin.svg'
import { ReactComponent as ShellPin } from '@dataplace.ai/assets/lib/markers/brand/shellPin.svg'
import { ReactComponent as SlovnaftPartnerPin } from '@dataplace.ai/assets/lib/markers/brand/slovnaftPartnerPin.svg'
import { ReactComponent as WatisPin } from '@dataplace.ai/assets/lib/markers/brand/watisPin.svg'
import { ReactComponent as maxBurgerPin } from '@dataplace.ai/assets/lib/markers/brand/maxBurgerPin.svg'
import { ReactComponent as burgerKingPin } from '@dataplace.ai/assets/lib/markers/brand/burgerKingPin.svg'
import { ReactComponent as subwayPin } from '@dataplace.ai/assets/lib/markers/brand/subwayPin.svg'
import { ReactComponent as pizzaHutPin } from '@dataplace.ai/assets/lib/markers/brand/pizzaHutPin.svg'
import { ReactComponent as CarrefourPin } from '@dataplace.ai/assets/lib/markers/brand/carrefourPin.svg'
import { ReactComponent as MediaMarktPin } from '@dataplace.ai/assets/lib/markers/brand/MediaMarktPin.svg'
import { ReactComponent as MediaexpertPin } from '@dataplace.ai/assets/lib/markers/brand/MediaexpertPin.svg'
import { ReactComponent as RtvEuroAgdPin } from '@dataplace.ai/assets/lib/markers/brand/RtvEuroAgdPin.svg'
import { ReactComponent as DiagnostykaPin } from '@dataplace.ai/assets/lib/markers/brand/DiagnostykaPin.svg'
import { ReactComponent as SynevoPin } from '@dataplace.ai/assets/lib/markers/brand/SynevoPin.svg'
import { ReactComponent as BadajToPin } from '@dataplace.ai/assets/lib/markers/brand/BadajToPin.svg'

export interface LocationProps {
  id: string
  address: string
  siteId?: string
  status: LocationStatus
  lat: number
  lng: number
  brand: string | null
  analysis?: {
    id: string
    email: string
  }
  createdAt: string
}

export const LOCATION_STATUSES = {
  accepted: 'accepted',
  inConstruction: 'in_construction',
  opened: 'opened',
  potential: 'potential',
  rejected: 'rejected',
  competition: 'competition',
} as const

export const LOCATION_STATUSES_RESPONSE_KEYS = {
  ...LOCATION_STATUSES,
  inConstruction: 'inConstruction' as const,
}

export type LocationStatus = typeof LOCATION_STATUSES[keyof typeof LOCATION_STATUSES]

export type LocationStatusResponseKeys = typeof LOCATION_STATUSES_RESPONSE_KEYS[
  keyof typeof LOCATION_STATUSES_RESPONSE_KEYS
]

export type AllLocationsDict = Record<LocationStatusResponseKeys, LocationProps[]>

export const pinOptions = {
  iconAnchor: [16, 43],
  iconSize: [32, 44],
  popupAnchor: [-1, -54],
  shadowAnchor: [11, 39],
  shadowSize: [33, 44],
} as IconOptions

export const brandMarkers = {
  '0e7314c7': HuzarPin,
  '1d845b0e': LotosPin,
  '9c1469b2': ShellPin,
  '45aefdc6': KFCPin,
  '67b655bc': AmicPin,
  '154df5d7': CircleKPin,
  '4185c04b': BliskaPin,
  '4621a39b': OrlenPin,
  a24ccbad: AviaPin,
  a71b685b: MolPin,
  aefb8539: BPPin,
  b941d5e0: WatisPin,
  c5c45f13: PieprzykPin,
  de6da01c: MCDPin,
  f5ad8ab2: SlovnaftPartnerPin,
  '1a101c93': maxBurgerPin,
  d2cd64e3: pizzaHutPin,
  '01771ae6': burgerKingPin,
  '509aee3a': subwayPin,
  a856c9ef: CarrefourPin,
  a1b2c3d4: MediaMarktPin,
  e5f6g7h8: MediaexpertPin,
  i9j0k1l2: RtvEuroAgdPin,
  '5tngdm8u': DiagnostykaPin,
  '83soegqz': SynevoPin,
  idsg6oen: BadajToPin,
} as const

export const markerFills = {
  accepted: '#DEB00D',
  inConstruction: '#9D0584',
  opened: '#569d05',
  potential: '#57B3CB',
  rejected: '#CC3C00',
  competition: '#000000',
} as const

export const defaultMapCoords = [52.2296756, 21.0122287]

export const zIndexes = {
  geoSuggestDropdown: 10,
  mapStylesDropdown: 401,
}
